export const MAX_SIZE_MB = 0.5;
export const MAX_WIDTH_OR_HEIGHT = 600;
export const USE_WEB_WORKER = true;